export const InvoiceFilter = {
  customerContext: 'filter[delivery.order.customerContext.id.equals]',
  customerName: 'filter[delivery.order.customerContext.customerName.icontains]',
  customerNumber:
    'filter[delivery.order.customerContext.customerNumber.icontains]',
  deliveryNumber: 'filter[delivery.number.icontains]',
  dueDateGreaterEqual: 'filter[dueDate.gte]',
  dueDateLessEqual: 'filter[dueDate.lte]',
  invoiceNumber: 'filter[local_number.icontains]',
  issueDateGreaterEqual: 'filter[issueDate.gte]',
  issueDateLessEqual: 'filter[issueDate.lte]',
  orderNumber: 'filter[delivery.order.brenntagOrderNumber.icontains]',
  poNumber: 'filter[purchaseOrderNumber.icontains]',
  salesGroup: 'filter[delivery.order.customerContext.salesGroup.id.equals]',
  searchQuery: 'search[query]',
  sort: 'sort',
  status: 'filter[status.equals]',
}

export const invoiceFilterDefaults = {
  page: '1',
  sort: '-issueDate',
}

export const invoiceFilterTranslationMap = {}

export type InvoiceFilters = typeof InvoiceFilter
export type InvoiceFilterKey = keyof InvoiceFilters
export type InvoiceFilterFnKey = keyof typeof invoiceFilterTranslationMap
export type InvoiceFilterOption = { id: InvoiceFilterKey; label: string }
